import { type CountryCode, COUNTRY_CODE } from './constants'

export type GetCountryFromUrlPayload = {
  hostname: string
}

export const getCountryFromUrl = ({ hostname }: GetCountryFromUrlPayload): CountryCode | null => {
  const {
    applicationUrl,
    applicationUrlAm,
    applicationUrlBy,
    applicationUrlGe,
    applicationUrlKg,
    applicationUrlKz,
    applicationUrlMd,
    applicationUrlTj,
    applicationUrlUz,
  } = useRuntimeConfig().public
  const toHostName = (url: string) => new URL(url).hostname

  switch (hostname) {
    case toHostName(applicationUrl):
      return COUNTRY_CODE.RU
    case toHostName(applicationUrlAm):
      return COUNTRY_CODE.AM
    case toHostName(applicationUrlBy):
      return COUNTRY_CODE.BY
    case toHostName(applicationUrlGe):
      return COUNTRY_CODE.GE
    case toHostName(applicationUrlKg):
      return COUNTRY_CODE.KG
    case toHostName(applicationUrlKz):
      return COUNTRY_CODE.KZ
    case toHostName(applicationUrlMd):
      return COUNTRY_CODE.MD
    case toHostName(applicationUrlTj):
      return COUNTRY_CODE.TJ
    case toHostName(applicationUrlUz):
      return COUNTRY_CODE.UZ
    default:
      return !import.meta.dev ? null : (useAppLocale().isRu ? COUNTRY_CODE.RU : COUNTRY_CODE.BY)
  }
}

export const getAppUrlByCountry = (country: CountryCode) => {
  const {
    applicationUrl,
    applicationUrlAm,
    applicationUrlBy,
    applicationUrlGe,
    applicationUrlKg,
    applicationUrlKz,
    applicationUrlUz,
    applicationUrlMd,
    applicationUrlTj,
  } = useRuntimeConfig().public

  switch (country) {
    case COUNTRY_CODE.BY:
      return applicationUrlBy
    case COUNTRY_CODE.KZ:
      return applicationUrlKz
    case COUNTRY_CODE.RU:
      return applicationUrl
    case COUNTRY_CODE.KG:
      return applicationUrlKg
    case COUNTRY_CODE.TJ:
      return applicationUrlTj
    case COUNTRY_CODE.UZ:
      return applicationUrlUz
    case COUNTRY_CODE.AM:
      return applicationUrlAm
    case COUNTRY_CODE.GE:
      return applicationUrlGe
    case COUNTRY_CODE.MD:
      return applicationUrlMd
  }
}
